import React from 'react';

import DiarySubscriber from './controls/diary';
import GroupSubscriber from './controls/groups';

class Subscriber extends React.Component<any> {
  render() {
    return (
      <>
        <GroupSubscriber />
        <DiarySubscriber />
        {this.props.children}
      </>
    );
  }
}

export default Subscriber;
